import React from 'react';
import { Table, TableProps } from 'antd';
import classNames from 'classnames';
import './table.scss';

export interface TableWrapperProps<T> extends TableProps<T> {
	className?: string;
	isTableWrapper?: boolean;
}

const TableWrapper = <T extends object = any>({ className, isTableWrapper, ...otherProps }: TableWrapperProps<T>) => {
	return <Table className={classNames({ 'table-wrapper': isTableWrapper }, className)} {...otherProps} />;
};

TableWrapper.defaultProps = {
	isTableWrapper: true,
	pagination: false,
	size: 'middle',
	dataSource: []
};

export default TableWrapper;
